import { debugLogger } from '@shared/debugLogger.js';
﻿import axios from 'axios';
//import { setupCache, buildWebStorage } from 'axios-cache-interceptor';
//axios = Axios.defaults.cache ? Axios : setupCache(Axios, {
//    storage: buildWebStorage(localStorage, 'axios-cache:'),
//    methods: ['get', 'post']
//});


const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

axios.defaults.headers['X-Time-Zone'] = userTimeZone;

// Need to add custom Date format to exclude conversion to the local browser timezone
// when browser creates new date object like "new Date()", it corrects for Daytime Saving Time.
// when browser create new date object like "new Date(1,1,1,1,1,)" it does not correct for DST.
// when user creates dates, it is assumed they mean local time. Local browser time zone
// is sent in the header of the Axios Request as X-Time-Zone.  On server, we convert any user entered
// DateTime to DST adjusted UTC time using the raw date info created by toCustomISOString
// and the TimeZone header.

// Define the toCustomISOString function for Date objects.
Date.prototype.toCustomISOString = function () {
    const year = this.getFullYear();
    const month = String(this.getMonth() + 1).padStart(2, '0');
    const day = String(this.getDate()).padStart(2, '0');
    const hours = String(this.getHours()).padStart(2, '0');
    const minutes = String(this.getMinutes()).padStart(2, '0');
    const seconds = String(this.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    // Debug logging for 404 errors
    if (error.response && error.response.status === 404) {
        console.error('[Axios Response] 404 Error:');
        console.error('[Axios Response] - URL:', error.config.url);
        console.error('[Axios Response] - Method:', error.config.method);
        console.error('[Axios Response] - Response Status:', error.response.status);
        console.error('[Axios Response] - Response Text:', error.response.statusText);
        console.error('[Axios Response] - Response Data:', error.response.data);
        console.error('[Axios Response] - Full error:', error);
    }
    
    if (error.response && (401 === error.response.status || 403 == error.response.status)) {
        location.href = "/Account/Login";
    }
    else {
        return Promise.reject(error);
    }
});

// Add an interceptor to modify request data
axios.interceptors.request.use((config) => {
    // Debug logging for LoadSessionConfig
    if (config.url && config.url.includes('LoadSessionConfig')) {
        debugLogger.log('[Axios Request] LoadSessionConfig request:');
        debugLogger.log('[Axios Request] - Method:', config.method);
        debugLogger.log('[Axios Request] - URL:', config.url);
        debugLogger.log('[Axios Request] - Base URL:', config.baseURL);
        debugLogger.log('[Axios Request] - Full URL:', config.baseURL ? config.baseURL + config.url : config.url);
        debugLogger.log('[Axios Request] - Data:', config.data);
        debugLogger.log('[Axios Request] - Headers:', config.headers);
    }
    
    // Recursively search for Date objects in the request data and apply toCustomISOString
    const transformDates = (data) => {
        for (const key in data) {
            if (data[key] instanceof Date) {
                data[key] = data[key].toCustomISOString();
            } else if (typeof data[key] === 'object') {
                transformDates(data[key]);
            }
        }
    }

    if (config.data) {
        transformDates(config.data);
    }

    return config;
});

export default axios;